/**
 * Lleva lo que alguien teclea en el buscador al folio tal como se guarda: `F-098`, `B-007`.
 *
 * Se escribe de muchas formas —«f98», «F098», «f-98», «98»— y el backend compara el folio
 * exacto, así que sin normalizar la mitad de las búsquedas fallarían por un cero o un guion. Solo
 * números cuenta como tarea (`F-`): es el caso más común y un bug casi siempre se cita con su `B`.
 * Devuelve `null` si no parece un folio, para no gastar una petición en algo que no lo es.
 */
export function normalizeFolio(raw: string): string | null {
  const m = (raw ?? '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '')
    .match(/^([FB])?-?0*(\d{1,6})$/)
  if (!m) return null
  return `${m[1] ?? 'F'}-${m[2].padStart(3, '0')}`
}
